import React from 'react';

/**
 * The scroll container pdf.js paints into. It stays empty in JSX: every page
 * container, canvas and highlight layer below it is created imperatively (see
 * pageElements.ts), so React must not own its children.
 */
const PdfPageSurface = React.forwardRef<HTMLDivElement>((_props, ref) => (
  <div
    ref={ref}
    className="flex flex-1 flex-col items-center overflow-auto bg-[#525659] p-4"
  />
));
PdfPageSurface.displayName = 'PdfPageSurface';

export default PdfPageSurface;
